export default __webpack_public_path__ + "static/media/fauna-old-dashboard.c3aedbfd.png";